// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import assetRepairEntity from './entities/asset-repair.json';
import assetRepairMenu from '../pages/asset-repair/menu.json';
import assetRepairFullForm from '../pages/asset-repair/forms/full.json';
import assetRepairContextForm from '../pages/asset-repair/forms/context.json';
import assetRepairMiniForm from '../pages/asset-repair/forms/mini.json';
import assetRepairLookupForm from '../pages/asset-repair/forms/lookup.json';
import assetRepairTableView from '../pages/asset-repair/views/table.json';
import assetRepairCardsView from '../pages/asset-repair/views/cards.json';
import assetRepairCalendarView from '../pages/asset-repair/views/calendar.json';
import assetRepairDashboardView from '../pages/asset-repair/views/dashboard.json';

/** Тип запису «Ремонт» зі сторінками пакета: меню, форми та подання з pages/asset-repair/. */
export const assetRepairDefinition: IRecordTypeDefinition = {
  ...assetRepairEntity,
  views: assembleViewSet({
      table: assetRepairTableView,
      cards: assetRepairCardsView,
      calendar: assetRepairCalendarView,
      dashboard: assetRepairDashboardView,
  }),
  form: assetRepairFullForm,
  forms: { full: assetRepairFullForm, context: assetRepairContextForm, mini: assetRepairMiniForm, lookup: assetRepairLookupForm },
  menu: assetRepairMenu,
} as IRecordTypeDefinition;
